import {FeatureName} from '@contentlab/types/project';

export interface UploadLimits {
  maxFileSizeBytes: number;
  maxDurationMillis: number;
  maxFileSizeDisplayKey: string;
  maxDurationDisplayKey: string;
}

// Default limits
export const DEFAULT_UPLOAD_LIMITS: UploadLimits = {
  maxFileSizeBytes: 2 ** 30, // 1GB
  maxDurationMillis: 3 * 60 * 1000, // 3 minutes
  maxFileSizeDisplayKey: '1GB',
  maxDurationDisplayKey: '3 min',
};

// Feature-specific limits
export const FEATURE_UPLOAD_LIMITS: Record<FeatureName, UploadLimits> = {
  [FeatureName.REFORMATTING]: {
    maxFileSizeBytes: 2 ** 30, // 1GB
    maxDurationMillis: 60 * 1000, // 1 minute
    maxFileSizeDisplayKey: '1GB',
    maxDurationDisplayKey: '60 sec',
  },
  [FeatureName.AI_DUBBING]: {
    maxFileSizeBytes: 3 * 2 ** 30, // 3GB
    maxDurationMillis: 30 * 60 * 1000, // 30 minutes
    maxFileSizeDisplayKey: '3GB',
    maxDurationDisplayKey: '30 min',
  },
  [FeatureName.REPHRASING]: DEFAULT_UPLOAD_LIMITS,
  [FeatureName.CAPTIONS]: DEFAULT_UPLOAD_LIMITS,
  [FeatureName.AI_AVATAR]: DEFAULT_UPLOAD_LIMITS,
  [FeatureName.UPSCALE]: DEFAULT_UPLOAD_LIMITS,
};

export const getUploadLimits = (
  feature: FeatureName | string
): UploadLimits => {
  return FEATURE_UPLOAD_LIMITS[feature as FeatureName] || DEFAULT_UPLOAD_LIMITS;
};
